import React from 'react';
import PropTypes from 'prop-types';

import {
  Box,
  IconButton,
  Typography
} from '@mui/material';

import { DeleteOutlineOutlined } from '@mui/icons-material';

import { diagnosisDialogStyles } from './diagnosisStyles';

const SelectedDiagnosisList = ({
  diagnoses,
  onRemove
}) => {
  if (!diagnoses.length) {
    return (
      <Box sx={diagnosisDialogStyles.emptyState}>
        <Typography sx={diagnosisDialogStyles.emptyText}>
          No diagnoses selected.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={diagnosisDialogStyles.selectedList}>
      {diagnoses.map(diagnosis => (
        <Box
          key={diagnosis.id}
          sx={diagnosisDialogStyles.selectedRow}>
          <Typography
            title={`${diagnosis.code} ${diagnosis.description}`}
            sx={diagnosisDialogStyles.selectedText}>
            {diagnosis.code} {diagnosis.description}
          </Typography>

          <IconButton
            size="small"
            aria-label={`Remove ${diagnosis.code}`}
            onClick={() => onRemove(diagnosis.id)}
            sx={diagnosisDialogStyles.deleteButton}>
            <DeleteOutlineOutlined
              sx={{ fontSize: 21 }}
            />
          </IconButton>
        </Box>
      ))}
    </Box>
  );
};

SelectedDiagnosisList.propTypes = {
  diagnoses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
      ]).isRequired,
      code: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired
    })
  ),
  onRemove: PropTypes.func
};

SelectedDiagnosisList.defaultProps = {
  diagnoses: [],
  onRemove: () => {}
};

export default SelectedDiagnosisList;